/* NORVAN — CINEMATIC MOTION LAYER. Vanilla JS, transform/opacity only, IO-based.
   Fully disabled under prefers-reduced-motion (reveals resolve instantly). */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(pointer: fine)').matches;

  function initReveals() {
    var host = document.getElementById('MainContent') || document.body;
    var sections = Array.prototype.slice.call(host.querySelectorAll('.shopify-section'));
    sections.forEach(function (section, sIndex) {
      if (sIndex === 0) return;
      var targets = section.querySelectorAll(
        '.product-card, .collection-card, .group-block-content, h2, .h2'
      );
      var list = targets.length ? Array.prototype.slice.call(targets) : [section];
      list.forEach(function (el, i) {
        if (el.hasAttribute('data-nv-reveal')) return;
        el.setAttribute('data-nv-reveal', '');
        el.style.setProperty('--nv-i', String(Math.min(i, 6)));
      });
    });
    if (reduceMotion || !('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-nv-reveal]').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
    document.querySelectorAll('[data-nv-reveal]').forEach(function (el) { io.observe(el); });
  }

  function initHeader() {
    var ticking = false;
    function update() { document.body.classList.toggle('nv-header-solid', window.scrollY > 40); ticking = false; }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initHeroParallax() {
    if (reduceMotion) return;
    var firstSection = document.querySelector('#MainContent .shopify-section');
    if (!firstSection) return;
    var media = firstSection.querySelector('img');
    if (!media) return;
    var ticking = false;
    function update() {
      var rect = firstSection.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < window.innerHeight) {
        var shift = Math.max(-60, Math.min(60, rect.top * -0.12));
        media.style.setProperty('--nv-parallax', shift.toFixed(1) + 'px');
      }
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initMagnetic() {
    if (reduceMotion || !finePointer) return;
    var candidates = document.querySelectorAll('.hero .button, .hero [class*="button"], .shopify-section:first-child .button');
    Array.prototype.slice.call(candidates).forEach(function (btn) {
      if (btn.closest('.nv-magnetic')) return;
      btn.classList.add('nv-magnetic');
      btn.addEventListener('pointermove', function (e) {
        var r = btn.getBoundingClientRect();
        var mx = e.clientX - (r.left + r.width / 2);
        var my = e.clientY - (r.top + r.height / 2);
        if (Math.hypot(mx, my) < r.width / 2 + 70) {
          btn.classList.add('is-pulling');
          btn.style.setProperty('--nv-mag-x', (mx * 0.28).toFixed(1) + 'px');
          btn.style.setProperty('--nv-mag-y', (my * 0.28).toFixed(1) + 'px');
        }
      });
      btn.addEventListener('pointerleave', function () {
        btn.classList.remove('is-pulling');
        btn.style.setProperty('--nv-mag-x', '0px');
        btn.style.setProperty('--nv-mag-y', '0px');
      });
    });
  }

  function boot() {
    document.body.classList.add('nv-ready');
    initHeader(); initReveals(); initHeroParallax(); initMagnetic();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', function () { setTimeout(initReveals, 50); });
})();
